import { Employee } from '@models/Employee'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { EMPLOYEE_URL } from '@utils/urls'

const fetchEmployees = (params: TableParams) =>
  SBAPI.FetchPaginated<Employee[]>(EMPLOYEE_URL, params)

const fetchEmployeeById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Employee>(`${EMPLOYEE_URL}/${id}`, params)

const createEmployee = (employee: Employee) =>
  SBAPI.Post(EMPLOYEE_URL, employee)

const updateEmployee = (employee: Employee) =>
  SBAPI.Put(`${EMPLOYEE_URL}/${employee.id}`, employee)

const deleteEmployee = (employee: Employee) =>
  SBAPI.Delete(`${EMPLOYEE_URL}/${employee.id}`)

export {
  createEmployee,
  deleteEmployee,
  fetchEmployeeById,
  fetchEmployees,
  updateEmployee,
}
